<template>
  <CardExpand
    somente-icone
    title="Clique aqui para pesquisa avançada"
    :expandido="filtroJurisprudencia.expandirPesquisaAvancada"
    @change="filtroJurisprudencia.expandirPesquisaAvancada = $event"
  >
    <div dense class="custom-alert">
      <v-icon size="36" color="#5C5CFF" class="mr-2">
        {{ mdiInformation }}
      </v-icon>
      <span> Todos os campos de pesquisa são opcionais </span>
    </div>

    <v-row dense class="ma-0 mt-2 mb-2">
      <v-col cols="6" class="pa-0 pr-4">
        <div class="d-flex justify-space-between align-end">
          <sds-input-control
            label="Período do Julgamento:"
            for="dtJulgamentoInicio"
          >
            <sds-date-picker
              id="dtJulgamentoInicio"
              v-model="filtroJurisprudencia.dtJulgamentoInicio"
              placeholder="dd/mm/aaaa"
              display-format="dd/MM/yyyy"
              :max-date="filtroJurisprudencia.dtJulgamentoFim"
              hide-details
            />
          </sds-input-control>
          <span class="mr-3 ml-3 mb-2">até</span>
          <sds-input-control for="dtJulgamentoFim">
            <sds-date-picker
              id="dtJulgamentoFim"
              v-model="filtroJurisprudencia.dtJulgamentoFim"
              placeholder="dd/mm/aaaa"
              display-format="dd/MM/yyyy"
              :min-date="filtroJurisprudencia.dtJulgamentoInicio"
            />
          </sds-input-control>
        </div>
      </v-col>

      <v-col cols="6" class="pa-0 pl-4">
        <div class="d-flex justify-space-between align-end">
          <sds-input-control
            label="Período do Registro:"
            for="dtRegistroInicio"
          >
            <sds-date-picker
              id="dtRegistroInicio"
              v-model="filtroJurisprudencia.dtRegistroInicio"
              placeholder="dd/mm/aaaa"
              :max-date="filtroJurisprudencia.dtRegistroFim"
            />
          </sds-input-control>
          <span class="mr-3 ml-3 mb-2">até</span>
          <sds-input-control for="dtRegistroFim">
            <sds-date-picker
              id="dtRegistroFim"
              v-model="filtroJurisprudencia.dtRegistroFim"
              placeholder="dd/mm/aaaa"
              :min-date="filtroJurisprudencia.dtRegistroInicio"
            />
          </sds-input-control>
        </div>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col cols="6" class="pa-0 pr-4">
        <sds-input-control label="Número do Recurso:" for="numero-recurso">
          <v-text-field
            id="numero-recurso"
            v-model="filtroJurisprudencia.nuRecurso"
            dense
            outlined
            hide-details
            :maxlength="100"
          />
        </sds-input-control>
      </v-col>
      <v-col cols="6" class="pa-0 pl-4">
        <sds-input-control label="Número do Registro:" for="numero-registro">
          <v-text-field
            id="numero-registro"
            v-model="filtroJurisprudencia.nuRegistro"
            dense
            outlined
            hide-details
            :maxlength="100"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Relator(a):" for="relator">
          <AutocompleteGraphql
            id="relator"
            v-model="filtroJurisprudencia.relator"
            :query="GET_RELATORES"
            item-text="nmRelator"
            item-value="relatores"
            no-data="Digite o(a) Relator(a)"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Magistrado Prolator:" for="magistrado">
          <AutocompleteGraphql
            id="magistrado"
            v-model="filtroJurisprudencia.magistradoProlator"
            :query="GET_PROLATORES"
            item-text="nmProlator"
            item-value="prolatores"
            no-data="Digite o Magistrado Prolator"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Seção:" for="secao">
          <AutocompleteGraphql
            id="secao"
            v-model="filtroJurisprudencia.secao"
            :query="GET_CARTORIOS"
            item-text="deTipoCartorio"
            item-value="tipoCartorios"
            no-data="Digite a Seção"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Órgão Julgador:" for="orgao-julgador">
          <AutocompleteGraphql
            id="orgao-julgador"
            v-model="filtroJurisprudencia.orgaoJulgador"
            :query="GET_VARAS"
            item-text="nmVara"
            item-value="varas"
            no-data="Digite o Órgão Julgador"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Comarca:" for="comarca">
          <AutocompleteGraphql
            id="comarca"
            v-model="filtroJurisprudencia.comarca"
            :query="GET_COMARCAS"
            item-text="nmComarca"
            item-value="comarcas"
            no-data="Digite a Comarca"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Classe:" for="classe">
          <AutocompleteGraphql
            id="classe"
            v-model="filtroJurisprudencia.classe"
            :query="GET_CLASSES"
            item-text="deClasse"
            item-value="classes"
            no-data="Digite a Classe"
          />
        </sds-input-control>
      </v-col>
    </v-row>

    <v-row dense class="ma-0 mb-2">
      <v-col class="pa-0">
        <sds-input-control label="Tipo de Boletim:" for="tipo-boletim">
          <AutocompleteGraphql
            id="tipo-boletim"
            v-model="filtroJurisprudencia.boletim"
            attach="#tipo-boletim"
            :query="GET_BOLETINS"
            :items-initialized="tiposBoletins"
            item-text="nmTipoBoletim"
            item-value="tipoBoletins"
            no-data="Digite o Boletim"
          />
        </sds-input-control>
      </v-col>
    </v-row>
  </CardExpand>
</template>

<script lang="ts" setup>
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiInformation } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import {
  GET_BOLETINS,
  GET_CARTORIOS,
  GET_CLASSES,
  GET_COMARCAS,
  GET_PROLATORES,
  GET_RELATORES,
  GET_VARAS,
} from '@/queries';
import { ConsultaJurisprudenciaSelecionadaStore } from '../../store/ConsultaJurisprudenciaSelecionadaStore';
import { storeToRefs } from 'pinia';
import { useLazyQuery } from '@vue/apollo-composable';
import { onMounted, ref } from 'vue';
import { IBoletim } from '@/views/boletins/types';

interface IProps {
  expandido?: boolean;
}

interface IEmits {
  (event: 'change:expandido', e: boolean): void;
}

defineProps<IProps>();

defineEmits<IEmits>();

const store = ConsultaJurisprudenciaSelecionadaStore();

const { filtroJurisprudencia } = storeToRefs(store);

const tiposBoletins = ref<IBoletim[]>([]);

const buscaInicialTiposBoletins = async () => {
  const { load, variables } = useLazyQuery(GET_BOLETINS);
  variables.value = { nmTipoBoletim: '' };
  tiposBoletins.value = (await load()).tipoBoletins;
};

onMounted(() => {
  buscaInicialTiposBoletins();
});
</script>
<style lang="scss" scoped>
::v-deep .v-select:not(.v-autocomplete) .v-select__slot input {
  visibility: visible;
}

:deep(.v-text-field__details) {
  display: none !important;
  height: 0px !important;
}
:deep(.v-input__slot) {
  margin: 0 !important;
}
</style>
